export enum JobType {
  MeterCreation = 'CreatingJob',
  MeterReading = 'ReadingJob',
  MeterReplacement = 'ReplacementJob',
}
